// extracted by mini-css-extract-plugin
module.exports = {"root":"CollectionCircle_root__3WuHX","image":"CollectionCircle_image__08OoB","label":"CollectionCircle_label__N2gl5","active":"CollectionCircle_active__GR3_H"};